import ListByDate from './styled';

export default ListByDate;
